import axios from 'axios';
import { getAxiosRequestConfig } from '../utilities/http';
import p, { ProviderSearchActionTypes } from './types/providerSearchActions';

export function fetchProviderData(
  page = 1,
  pageSize = 10,
  searchInput = '',
  sortBy = '',
  recommendation = '',
  entityType = ''
): ProviderSearchActionTypes {
  const params = {
    offset: (page - 1) * pageSize,
    limit: pageSize,
    sortBy,
    recommendation,
    entityType,
  };

  const payload = serializeParams(params, searchInput);

  return {
    type: p.FETCH_PROVIDER_DATA,
    payload: axios.get(`${process.env.REACT_APP_API_BASE_URL || ''}/api/getProviderExperience`, {
      params: payload,
      ...getAxiosRequestConfig(),
    }),
  };
}

const serializeParams = (params: any, searchInput: string) => {
  const updatedParams = { ...params };
  updatedParams.searchText = searchInput;

  // Remove empty, undefined, or null values
  Object.keys(updatedParams).forEach(key => {
    if (
      updatedParams[key] === '' ||
      updatedParams[key] === undefined ||
      updatedParams[key] === null
    ) {
      delete updatedParams[key];
    }
  });

  return updatedParams;
};

export function setSearchInput(input: string): ProviderSearchActionTypes {
  return {
    type: p.SET_SEARCH_INPUT,
    payload: input,
  };
}

export function setSortBy(input: string): ProviderSearchActionTypes {
  return {
    type: p.SET_SORT_BY,
    payload: input,
  };
}

export function setRecommendationFilter(input: string): ProviderSearchActionTypes {
  return {
    type: p.SET_RECOMMENDATION,
    payload: input,
  };
}

export function setEntityTypeFilter(input: string): ProviderSearchActionTypes {
  return {
    type: p.SET_ENTITY_TYPE,
    payload: input,
  };
}

export function setActionInitiated(input: string): ProviderSearchActionTypes {
  return {
    type: p.SET_ACTION_INITIATED,
    payload: input,
  };
}

export function setSelectedProviderId(input: string): ProviderSearchActionTypes {
  return {
    type: p.SET_SELECTED_PROVIDER_ID,
    payload: input,
  };
}

export function createProviderSearch(formData: any): ProviderSearchActionTypes {
  const provider = serializeFormData(formData);
  return {
    type: p.CREATE_PROVIDER_EXPERIENCE,
    payload: axios.post(
      `${process.env.REACT_APP_API_BASE_URL || ''}/api/createProviderExperience`,
      provider,
      getAxiosRequestConfig()
    ),
  };
}

export function updateProviderSearch(formData: any): ProviderSearchActionTypes {
  const provider = serializeFormData(formData);
  return {
    type: p.UPDATE_PROVIDER_EXPERIENCE,
    payload: axios.put(
      `${process.env.REACT_APP_API_BASE_URL || ''}/api/updateProviderExperience/${provider.npi}`,
      provider,
      {
        headers: { 'Content-Type': 'application/json' },
        ...getAxiosRequestConfig(),
      }
    ),
  };
}

function serializeFormData(formData: any) {
  const serializedProvider = {
    provider_name: formData.providerName,
    npi: formData.providerNPI,
    ein: formData.providerTaxID,
    entity_type: formData.entityType,
    recommendation: formData.recommendation,
    external_notes: formData.externalNotes,
    internal_notes: formData.internalNotes,
    active: formData.active,
    lastupdateddate: new Date(),
  };
  return serializedProvider;
}
